import { useParams } from 'react-router-dom';
import usePromptDoc from '@actions/services/firestore/browser/prompt/use';
import EntityBreadcrumb from '../EntityBreadcrumb';
import { PromptCrumbProps } from './types';

const PromptCrumb = ({ param, isCurrentPage = false }: PromptCrumbProps) => {
    const params = useParams();
    const promptId = params[param];
    const agentId = params.agentId;

    const { data: prompt, isLoading } = usePromptDoc(promptId || '', {
        disabled: !promptId,
    });

    const label = isLoading ? '...' : prompt?.name || `Prompt ${promptId?.slice(0, 8)}...`;

    const href = agentId && promptId ? `/agents/${agentId}/prompts/${promptId}` : '/prompts';

    return (
        <EntityBreadcrumb
            label={label}
            entityId={promptId || ''}
            entityType="Prompt"
            href={href}
            isCurrentPage={isCurrentPage}
            isLoading={isLoading}
        />
    );
};

export default PromptCrumb;
